import { createContext, useContext, useState, useEffect } from 'react';
import { translations, languages } from '../config/translations';

const LanguageContext = createContext();

// Default language is English
const DEFAULT_LANGUAGE = 'en';
const STORAGE_KEY = 'selectedLanguage';

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Check localStorage or default to English
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved && translations[saved]) {
        return saved;
      }
    }
    return DEFAULT_LANGUAGE;
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, language);
  }, [language]);

  // Get translations for current language
  const t = translations[language] || translations[DEFAULT_LANGUAGE];

  // Function to change language
  const changeLanguage = (langCode) => {
    if (translations[langCode]) {
      setLanguage(langCode);
    }
  };

  // Get current language info
  const currentLanguage = languages.find((l) => l.code === language) || languages[0];

  return (
    <LanguageContext.Provider value={{ 
      language, 
      setLanguage, 
      changeLanguage,
      t, 
      languages,
      currentLanguage 
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
